function showFinishPopup(){
    $('#modal-finish').modal({
            show: true
        })
}
var letters = {
    a:'qwsxz',
    b:'vghn ',
    c:'xdfv ',
    d:'serfcx',
    e:'wsdr43',
    f:'drtgvc',
    g:'ftyhbv',
    h:'gyujnb',
    i:'ujko98',
    j:'huikmn',
    k:'jiol,m',
    l:'kop;.,',
    m:'njk, ',
    n:'bhjm ',
    o:'i90plk',
    p:'lo0-',
    q:'aw21',
    r:'edft5',
    s:'awedxz',
    t:'rfgy6',
    u:'yhji7',
    v:'cfgb ',
    w:'qase2',
    x:'zsdc ',
    y:'tghu7',
    z:'asx '
    
}
function getLetter(key){
    var chance = 20 //change to set how often you don't get the letter you want (higher = less often, 0 = never)
    if(letters.hasOwnProperty(key)){
        var options = letters[key]
        for(var i = 0; i < chance;i++){
            options += key
        }
//       console.log('options',options)
        var pos = Math.floor(Math.random() * options.length)
        var letter = options.substr(pos,1)
        return letter
    } else {
        return key
    }
}
$(document).ready(function(e){
    console.log('finish ready')
    $('.feedback-box').keydown(function(e){
//        console.log('typed ',e)
        if(letters.hasOwnProperty(e.key)){
            //only affect the letters we care about, everything else is passed through
            e.preventDefault()
            
            var cursorPos = getCursorPos($(this).get(0))
           
            var letter = getLetter(e.key)
            var currentVal = $('.feedback-box').val()
            
            $('.feedback-box').val( currentVal.slice(0, cursorPos.start) + letter + currentVal.slice(cursorPos.end))
            setCursorPos($(this).get(0),cursorPos.start + 1)
            if($('.feedback-box').val() && $('.feedback-box').val().length >= 30){
                 $('.btn-submit').removeClass('not-allowed').attr('disabled',false)
            }
        }
        
    })
    $('.btn-submit').click(function(e){
        e.preventDefault()
        fakeSubmit()
        $(this).addClass('not-allowed').attr('disabled',true)
    })
    $('.js-btn-exit').click(function(e){
        window.close()
    })
})
function fakeSubmit(){
    $('.feedback-box').addClass('fade-out-text').delay(500).queue(function(next){
        $(this).val('Thank you for your submission')
        $(this).addClass('not-allowed').attr('disabled',true)
        $(this).removeClass('fade-out-text')
        next()
    }).delay(500).queue(function(next){
        $('#modal-finish').modal({
            show: true, 
        })
        next()
    })


}

/*
 * https://stackoverflow.com/questions/7745867/how-do-you-get-the-cursor-position-in-a-textarea
 */
function getCursorPos(input) {
//    console.log(input)
    if ("selectionStart" in input && document.activeElement == input) {
        return {
            start: input.selectionStart,
            end: input.selectionEnd
        };
    }
    else if (input.createTextRange) {
        var sel = document.selection.createRange();
        if (sel.parentElement() === input) {
            var rng = input.createTextRange();
            rng.moveToBookmark(sel.getBookmark());
            for (var len = 0;
                     rng.compareEndPoints("EndToStart", rng) > 0;
                     rng.moveEnd("character", -1)) {
                len++;
            }
            rng.setEndPoint("StartToStart", input.createTextRange());
            for (var pos = { start: 0, end: len };
                     rng.compareEndPoints("EndToStart", rng) > 0;
                     rng.moveEnd("character", -1)) {
                pos.start++;
                pos.end++;
            }
            return pos;
        }
    }
    return -1;
}

function setCursorPos(input, start, end) {
    if (arguments.length < 3) end = start;
    if ("selectionStart" in input) {
        setTimeout(function() {
            input.selectionStart = start;
            input.selectionEnd = end;
        }, 1);
    }
    else if (input.createTextRange) {
        var rng = input.createTextRange();
        rng.moveStart("character", start);
        rng.collapse();
        rng.moveEnd("character", end - start);
        rng.select();
    }
}

//function enableInputs(){
//    $('.btn-submit').removeClass('not-allowed').attr('disabled',false)
//}
//enableInputs()